import { defineStore } from "pinia";
import { showError } from "src/utils/notify";
import { groupListingByKey } from "src/utils";

export const useFriendStore = defineStore("friend", {
  state: () => ({
    friends: null,
    loadFriends: false,
    stores: {},
    campaigns: [],
    loadCampaigns: false,
    friendOfFriends: {},
    allowedStores: [],
    friendEarnings: {},
    blockList: [],
    loadBlock: false,
    findFriendList: [],
    loadFindFriendList: false,
    friendsList: [],
    loadFriendsList: false,
  }),
  getters: {
    friendDeals: (state) => {
      return groupListingByKey(state.campaigns, "account.id");
    },
    friendList: (state) => {
      return state.friends;
    },
    friendStores: (state) => {
      return state.stores;
    },
    friendCampaigns: (state) => {
      return state.campaigns;
    },
    friendOfFriendList: (state) => {
      return state.friendOfFriends;
    },
    allowedStoresList: (state) => {
      return state.allowedStores;
    },
    friendEarningList: (state) => {
      return state.friendEarnings;
    },
  },
  actions: {
    resetStore() {
      this.friends = null;
      this.loadFriends = false;
      this.stores = {};
      this.campaigns = [];
      this.friendOfFriends = {};
      this.allowedStores = [];
      this.friendEarnings = {};
      this.blockList = [];
      this.loadBlock = false;
      this.findFriendList = [];
      this.loadFindFriendList = false;
      this.loadCampaigns = false;
    },
    async getFriendsList() {
      try {
        this.friends = null;
        this.loadFriends = false;
        let data = await this.$request.get(this.apiEndpoints.FRIENDS);
        if (data.data) {
          this.loadFriends = true;
          this.friends = data.data.items ? data.data.items : null;
        }
      } catch (error) {}
    },
    async getFriendsListPageWise(params) {
      try {
        let searchstr = "";
        if (params.hasOwnProperty("search") && params.search.length > 0) {
          searchstr = "&search=" + params.search;
        }
        let response = await this.$request.get(
          this.apiEndpoints.FRIENDS_PAGINATION(
            params.page,
            params.per_page,
            params.hasOwnProperty("friendId") ? params.friendId : ""
          ) + searchstr
        );
        if (params.page == 1) {
          this.resetFriendListData();
        }
        if (response.data) {
          Array.prototype.push.apply(this.friendsList, response.data.items);
          this.loadFriendsList = true;
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    resetFriendListData() {
      this.friendsList = [];
      this.loadFriendsList = false;
    },
    async getFriendStores(friendId) {
      try {
        let data = await this.$request.get(
          this.apiEndpoints.FRIEND_STORES(friendId)
        );
        if (data.data && data.data.status) {
          this.stores = data.data.items;
        } else this.stores = [];
      } catch (error) {}
    },
    async getFriendCampaigns(friendId) {
      this.loadCampaigns = false;
      try {
        let data = await this.$request.get(
          this.apiEndpoints.FRIEND_CAMPAIGNS(friendId)
        );
        if (data.data) {
          this.campaigns = data?.data?.items ? data?.data?.items : [];
        }
        this.loadCampaigns = true;
      } catch (error) {}
    },
    async getFriendFriends(friendId) {
      try {
        let data = await this.$request.get(
          this.apiEndpoints.FRIEND_FRIENDS(friendId)
        );
        if (data.data && data.data.status) {
          this.friendOfFriends = data.data.items;
        } else this.friendOfFriends = [];
      } catch (error) {}
    },
    async getFriendEarningHistory(friendId, perPage, page) {
      try {
        let data = await this.$request.get(
          this.apiEndpoints.FRIEND_EARNING_HISTORY(friendId, perPage, page)
        );
        if (data.data && data.data.status) {
          this.friendEarnings = data.data.items;
        } else this.friendEarnings = [];
      } catch (error) {}
    },
    async getMyAllowedStores(friendId, from = "") {
      try {
        let data = await this.$request.get(
          from == "friend-detail"
            ? this.apiEndpoints.MY_ALLOWED_STORES(friendId)
            : this.apiEndpoints.ALLOWED_STORES(friendId)
        );
        if (data.data) {
          this.allowedStores = data.data.items ? data.data.items : [];
        }
      } catch (error) {}
    },
    async sendTeamRequest(friendId, storeId) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.SEND_TEAM_REQUEST(friendId, storeId)
        );
        if (data.data) {
          return data.data;
        }
      } catch (error) {}
    },
    async getBlockedFriendsList() {
      try {
        this.blockList = [];
        this.loadBlock = false;
        let data = await this.$request.get(this.apiEndpoints.BLOCKED_LIST);
        if (data.data) {
          this.blockList = data.data.items;
          this.loadBlock = true;
        }
      } catch (error) {}
    },
    async unBlockedUser(friendId) {
      try {
        let data = await this.$request.get(
          this.apiEndpoints.UNBLOCKED_FRIEND(friendId)
        );
        if (data.data) {
          return data.data;
        }
      } catch (error) {}
    },
    async getFindFriendsList(params) {
      try {
        this.findFriendList = [];
        this.loadFindFriendList = false;
        let data = await this.$request.post(
          this.apiEndpoints.FRIEND_SEARCH,
          params
        );
        if (data.data && data.data.status) {
          this.findFriendList = data.data.customers;
          this.loadFindFriendList = true;
        }
        return true;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        return false;
      }
    },
  },
});
